package com.fireavert.properties.comm_v2_conversion_dialog

data class CommV2ConversionDialogViewState(
    val isLoading: Boolean = true,
    val success: Boolean = false,
    val isConfirmed: Boolean = false,
    val errorMessages: List<String> = emptyList()
)
